var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('Header',{staticStyle:{"background":"#00101A"}}),_c('router-view',{staticStyle:{"padding":"90px 30px 30px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }